import React, { useState, useEffect } from 'react'; 
import { Link } from 'react-router-dom';
import TopHeader from './TopBar';
import RSMobileMenu from './RSMobileMenu';
import MenuItems from './MenuItems';
import Logo from '../../../assets/img/logo/logo.png';
import whiteLogo from '../../../assets/img/logo/white-logo.png';
import upwork from '../../../assets/img/up.png';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [menuData, setMenuData] = useState(null);

    useEffect(() => {
        // Sticky is displayed after scrolling for 100 pixels
        const toggleVisibility = () => {
            if (window.pageYOffset > 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);

        // Fetch menu data from API
        const fetchMenuData = async () => {
            try {
                const response = await fetch('https://yautiktechnology.com/api/headers');
                const data = await response.json();
                setMenuData(data[0]); // Assuming the data is an array and we're using the first item
            } catch (error) {
                console.error("Error fetching menu data:", error);
            }
        };

        fetchMenuData();
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const searchModalAdd = () => {
        document.body.classList.add('modal-open');
    };

    return (
        <React.Fragment>
            <div className="full-width-header">
                <header id="rs-header" className="rs-header">
                    <TopHeader />
                    <div className={isVisible ? 'menu-area menu-sticky sticky' : 'menu-area menu-sticky'}>
                        <div className="container">
                            <div className="logo-area hidden-md">
                                <Link to="/"><img className="sticky-logo" src={Logo} alt="logo" /></Link>
                            </div>
                            <div className="rs-menu-area">
                                <div className="main-menu">
                                    <div className="mobile-menu md-display-block">
                                        <Link to="/" className="mobile-normal-logo"><img src={whiteLogo} alt="logo" /></Link>
                                        <div className=" up-mob">
                                            {menuData && (
                                                <a href={menuData.upworkUrl} target="_blank" className="mobile-normal-logo mobile-upwork">
                                                    <img src={upwork} alt="logo" />
                                                </a>
                                            )}
                                        </div>
                                        <Link to="/" className="mobile-sticky-logo"><img src={Logo} alt="logo" /></Link>
                                        <Link to="#" className="rs-menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                                            <i className="fa fa-bars"></i>
                                        </Link>
                                    </div>
                                    <nav className="rs-menu hidden-md">
                                        <ul className="nav-menu">
                                            {menuData && menuData.menuNameWithUrl && (
                                                <>
                                                    <li><Link to={menuData.menuNameWithUrl.Home}>Home</Link></li>
                                                    <li><Link to={menuData.menuNameWithUrl.About}>About</Link></li>
                                                    <li className="menu-item-has-children">
                                                        <Link to={menuData.menuNameWithUrl.Services}>Services</Link>
                                                        <ul className="sub-menu">
                                                            {Object.entries(menuData.servicesDropdownUrl).map(([service, url]) => (
                                                                <li key={service}><Link to={url}>{service}</Link></li>
                                                            ))}
                                                        </ul>
                                                    </li>
                                                    <li><Link to={menuData.menuNameWithUrl.Industries}>Industries</Link></li>
                                                    <li><Link to={menuData.menuNameWithUrl.Contact}>Contact</Link></li>
                                                </>
                                            )}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                            <div className="expand-btn-inner search-icon hidden-sticky hidden-md">
                                <div className="toolbar-sl-share">
                                    <ul className="social">
                                        {menuData && (
                                            <>
                                                <li>
                                                    <a href={menuData.linkedinUrl} target="_blank"><i className="fa fa-linkedin"></i></a>
                                                </li>
                                                <li>
                                                    <a href={menuData.upworkUrl} target="_blank">
                                                        <img className="upwork" src={menuData.upworkImg} alt="upwork" />
                                                    </a>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <RSMobileMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
                    <div onClick={() => setMenuOpen(false)} className={menuOpen ? "body-overlay show" : "body-overlay"}></div>

                </header>
            </div>
        </React.Fragment>
    );
};

export default Header;
